import { Settings } from 'lucide-react';
import AnalyticsMenu from './AnalyticsMenu';
import useWindowSize from '../../hooks/useWindowSize';
import MyDrawer from '../../components/myDrawer/MyDrawer';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';

const AnalyticsLayoutMenu = () => {
  const { isMobile } = useWindowSize();

  return isMobile ? (
    <MyDrawer
      btnClassname="settings_btn"
      icon={<MyLucideIcon icon={Settings} />}
      noExtraBtn
    >
      <AnalyticsMenu />
    </MyDrawer>
  ) : (
    <AnalyticsMenu />
  );
};

export default AnalyticsLayoutMenu;
